exports = module.exports = require("../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-300d4855] {\n  width: 175px;\n  margin-bottom: 45px;\n}", ""]);

// exports
